import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { YSButton } from "../../../uikit/YSButton";
import { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import * as yup from "yup";
import DRxIcon from "../../../images/icons/DRxIcon.svg";
import AtlasIcon from "../../../images/atlassmlIcon.png";
import IMAIcon from "../../../images/IMA_icon.png";
import ZipChartIcon from "../../../images/ZipchartIcon.png";
import OrteleIcon from "../../../images/OrteleIcon.png";
import MedifactsIcon from "../../../images/MedifactsIcon.png";
import {
  greyColor,
  warnColor,
  InputSMBoxStyle,
  BtnSMGroupStyle,
} from "../../../Theme";
import { TicketFollowUp, TicketInfo } from "../../../Apis/AuthApiServices";
import YSSnackBar from "../../../uikit/YSSnackBar";
import DRxTextarea from "../../../uikit/DRxTextarea";

const initialStateNewTicket = {
  createdDate: "",
  dateOnIssueOccured: "",
  detailedDescription: "",
  drxUserId: "",
  expectedResolutionDate: "",
  issueOccuredTo: "",
  issueRelated: "",
  issueSolution: "",
  issueSummery: "",
  mailId: "",
  messages: "",
  modiefiedDate: "",
  phoneNumber: "",
  praticeId: "",
  prescribingAs: "",
  stateOfPratice: "",
  ticketId: "",
  ticketStatus: "",
  vendorId: "",
  userComments: "",
};

export default function NewTicket(props: any) {
  const { id, handleHideTicketFollowUpPopupClick } = props;
  const [data, setData] = useState(initialStateNewTicket);
  const [loading, setLoading] = useState(false);
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  let vendor = localStorage.getItem("themeSelection");

  let LogoIcon: any;
  let LogoName: any;
  if (vendor === "imasys") {
    LogoIcon = IMAIcon;
    LogoName = "IMA Rx";
  } else if (vendor === "atlas-sml") {
    LogoIcon = AtlasIcon;
    LogoName = "Atlas Rx";
  } else if (vendor === "zipchart") {
    LogoIcon = ZipChartIcon;
    LogoName = "Zipchart Rx";
  } else if (vendor === "medifacts") {
    LogoIcon = MedifactsIcon;
    LogoName = "Medifacts Rx";
  } else if (vendor === "ortele") {
    LogoIcon = OrteleIcon;
    LogoName = "Ortele Rx";
  } else {
    LogoIcon = DRxIcon;
    LogoName = "H2H Digital Rx";
  }
  const ticketFollowUpInfo = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append("ticketId", id);
      const result: any = await TicketInfo(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response[0]);
      } else {
        setData(result?.data?.digitalRxStatusMessage);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const ticketFollowUpSubmit = async (values: any) => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append("ticketId", id);
      params.append("userComment", values.userComments);
      const result: any = await TicketFollowUp(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        ticketFollowUpInfo();
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  useEffect(() => {
    ticketFollowUpInfo();
  }, []);

  const messages = Object.values(data?.messages || []);

  return loading ? (
    <Grid
      container
      justifyContent={"center"}
      alignItems={"center"}
      height={"50vh"}
    >
      <CircularProgress />
    </Grid>
  ) : (
    <Formik
      initialValues={data}
      validationSchema={yup.object({
        userComments: yup
          .string()
          .required("Please provide valid userComment ")
          .min(5, "userComment is Too Short!"),
      })}
      onSubmit={(values) => {
        ticketFollowUpSubmit(values);
      }}
    >
      {(commentprops) => (
        <Form onSubmit={commentprops.handleSubmit}>
          <Grid
            container
            item
            xs={12}
            spacing={0}
            alignItems="center"
            justifyContent="center"
            columnSpacing={4}
            style={{
              margin: "-20px ",
            }}
          >
            <Grid item xs={12}>
              <Grid
                container
                item
                xs={12}
                spacing={0}
                alignItems="top"
                justifyContent="space-between"
                columnSpacing={4}
                paddingBottom={2}
                style={{
                  background: "#D9D9D9",
                }}
              >
                <Grid item xs={12} md={6}>
                  <Box style={{ display: "flex", gap: 3, marginTop: 10 }}>
                    <Typography
                      component="div"
                      color={greyColor}
                      variant="body2"
                      fontWeight={600}
                    >
                      Ticket Id:
                    </Typography>
                    <Typography
                      component="div"
                      color={greyColor}
                      variant="body2"
                    >
                      {id ?? ""}
                    </Typography>
                  </Box>{" "}
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box style={{ display: "flex", gap: 3, marginTop: 10 }}>
                    <Typography
                      component="div"
                      color={greyColor}
                      variant="body2"
                      fontWeight={600}
                    >
                      Ticket Created on:
                    </Typography>
                    <Typography
                      component="div"
                      color={greyColor}
                      variant="body2"
                    >
                      {data?.createdDate ?? ""}
                    </Typography>
                  </Box>{" "}
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box style={{ display: "flex", gap: 3, marginTop: 10 }}>
                    <Typography
                      component="div"
                      color={greyColor}
                      variant="body2"
                      fontWeight={600}
                    >
                      Ticket Summary:
                    </Typography>
                    <Typography
                      component="div"
                      color={warnColor}
                      variant="body2"
                    >
                      {data?.issueSummery ?? ""}
                    </Typography>
                  </Box>{" "}
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box style={{ display: "flex", gap: 3, marginTop: 10 }}>
                    <Typography
                      component="div"
                      color={greyColor}
                      variant="body2"
                      fontWeight={600}
                    >
                      Ticket Description:
                    </Typography>
                    <Typography
                      component="div"
                      color={greyColor}
                      variant="body2"
                    >
                      {data?.detailedDescription ?? ""}
                    </Typography>
                  </Box>{" "}
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box style={{ display: "flex", gap: 3, marginTop: 10 }}>
                    <Typography
                      component="div"
                      color={greyColor}
                      variant="body2"
                      fontWeight={600}
                    >
                      Estimated Closing Date:
                    </Typography>
                    <Typography
                      component="div"
                      color={greyColor}
                      variant="body2"
                    >
                      {data?.expectedResolutionDate ?? ""}
                    </Typography>
                  </Box>{" "}
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box style={{ display: "flex", gap: 3, marginTop: 10 }}>
                    <Typography
                      component="div"
                      color={greyColor}
                      variant="body2"
                      fontWeight={600}
                    >
                      Issue Solution:
                    </Typography>
                    <Typography
                      component="div"
                      color={greyColor}
                      variant="body2"
                    >
                      {data.issueSolution ?? ""}
                    </Typography>
                  </Box>{" "}
                </Grid>
              </Grid>{" "}
              <Grid
                container
                item
                xs={12}
                spacing={0}
                alignItems="top"
                justifyContent="space-between"
                columnSpacing={5}
              >
                <Grid item xs={12}>
                  <Box style={{ height: 250 }} overflow={"auto"}>
                    {messages.map((item: any, key) => (
                      <>
                        <Box
                          style={{
                            marginLeft: 40,
                            position: "relative",
                            display: "flex",
                            justifyContent:
                              item.author === "h2hdigitalrx-user"
                                ? "flex-end"
                                : "flex-start",
                          }}
                        >
                          {item.author !== "h2hdigitalrx-user" && (
                            <img
                              src={LogoIcon}
                              loading="lazy"
                              alt={LogoName}
                              style={{
                                position: "absolute",
                                marginLeft: -35,
                                marginTop: 5,
                                maxWidth: 40,
                              }}
                            />
                          )}
                          <Box
                            style={{
                              minWidth: 250,
                              backgroundColor:
                                item.author === "h2hdigitalrx-user"
                                  ? "#add8e67a"
                                  : "#90ee9038",
                              border:
                                item.author === "h2hdigitalrx-user"
                                  ? "1px solid lightblue"
                                  : "1px solid lightgreen",
                              margin: "5px 10px",
                              padding: "10px 15px",
                              textAlign:
                                item.author === "h2hdigitalrx-user"
                                  ? "right"
                                  : "left",
                              borderRadius:
                                item.author === "h2hdigitalrx-user"
                                  ? "10px 0px 10px 10px"
                                  : "0px 10px 10px 10px",
                            }}
                          >
                            <Grid
                              container
                              justifyContent={"space-between"}
                              alignItems={"center"}
                              direction={"row"}
                            >
                              <Grid container direction={"column"} gap={1}>
                                <Typography fontWeight={"bold"}>
                                  {item.message}{" "}
                                </Typography>
                                <Typography
                                  component="div"
                                  fontStyle={"italic"}
                                  variant="caption"
                                >
                                  {item.date}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>
                      </>
                    ))}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box style={{ margin: 10 }}>
                    <InputSMBoxStyle
                      className="widthauto textarea78"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <DRxTextarea
                        className={""}
                        id={""}
                        placeholder={"Enter your comments"}
                        name="userComments"
                      />
                    </InputSMBoxStyle>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <BtnSMGroupStyle
                    style={{ marginBottom: 30, marginRight: 10 }}
                  >
                    <YSButton
                      size="large"
                      className=""
                      color="secondary"
                      dataTestId="submitBtn"
                      variant="outlined"
                      disabled={false}
                      type="button"
                      children={"Cancel"}
                      onClick={handleHideTicketFollowUpPopupClick}
                    />
                    <YSButton
                      size="large"
                      className=""
                      color="secondary"
                      dataTestId="submitBtn"
                      variant="outlined"
                      disabled={false}
                      type={"reset"}
                      children={"Reset"}
                    />{" "}
                    <YSButton
                      size="large"
                      className=""
                      color="primary"
                      dataTestId="submitBtn"
                      variant="contained"
                      disabled={false}
                      type="submit"
                      children={"Post"}
                    />{" "}
                  </BtnSMGroupStyle>
                </Grid>
              </Grid>{" "}
            </Grid>{" "}
          </Grid>{" "}
          <YSSnackBar
            message={stateData.message}
            variant={stateData.variant}
            open={stateData.open}
            handleClose={() => {
              setStateData((prevState: any) => {
                return { ...prevState, open: false };
              });
            }}
          />
        </Form>
      )}
    </Formik>
  );
}
